import { APICalendarMeetingTemplateSchema } from '../api/useCreateCalendarMeetingTemplate';
import { UseUserCalendarReturnData } from '../hooks/useUserCalendar';
import { findCalendarByEmail } from './findCalendarByEmail';

export type UnresolvedParticipant = {
  email: string;
  name: string;
  isOrganizer: boolean;
};

// A calendar that has left the organization's list matches nothing and would
// otherwise be dropped silently, taking the organizer with it.
export const getUnresolvedTemplateParticipants = (
  data: APICalendarMeetingTemplateSchema | undefined,
  userCalendars: UseUserCalendarReturnData
): UnresolvedParticipant[] =>
  (data?.participants ?? [])
    .filter(
      (participant) => !findCalendarByEmail(userCalendars, participant.email)
    )
    .map((participant) => ({
      email: participant.email,
      name: participant.name,
      isOrganizer: !!participant.isOrganizer
    }));
